import React from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import { useState } from "react";
import ItemUnitsPriceFormContent from "./ItemUnitsPriceFormContent";
import AppForm from "../../../../partials/content/Forms/AppForm";
import { useEffect } from "react";
import {
  getItemUnitsPrice,
  saveItemUnitsPrice,
} from "../../../../services/sales/salesService";
const itemUnitPriceSchema = yup.object().shape({
  itemUnitsPrice: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      itemName: yup.string().required("Item Variant is required"),
      uomName: yup.string().required("Unit is required"),
      price: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Selling Price is required")
        .moreThan(0, "Selling Price cannot be zero or empty")
        .default(0),
    })
  ),
});
function ItemUnitsPriceForm({
  customerGroupID = 0,
  itemID = 0,
  onConfirmSave,
  onCloseDialog,
}) {
  const [itemUnitsPrice, setItemUnitsPrice] = useState([]);
  const [item, setItem] = useState({});
  useEffect(() => {
    getItemUnitsPriceData(customerGroupID, itemID);
  }, [customerGroupID, itemID]);
  async function getItemUnitsPriceData(customerGroupID = 0, itemID = 0) {
    const response = await getItemUnitsPrice(customerGroupID, itemID);
    const { data } = response.data;
    setItemUnitsPrice(data.itemUnitsPrice);
    setItem(data.item);
  }
  return (
    <React.Fragment>
      <AppForm
        initialValues={{
          item,
          itemUnitsPrice,
        }}
        validationSchema={itemUnitPriceSchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title:
                "Are you sure want to save this Item Alternative Unit Prices ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveItemUnitsPrice(values.itemUnitsPrice).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <ItemUnitsPriceFormContent
          customerGroupID={customerGroupID}
          onCloseDialog={onCloseDialog}
        />
      </AppForm>
    </React.Fragment>
  );
}

export default ItemUnitsPriceForm;
